<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    data-dd-action-name="confirmation-modal.close-button"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross')"
  ></button>
</div>

<form [formGroup]="form" (validSubmit)="confirm()">
  <div class="modal-body">
    @if (text) {
      <p [innerHTML]="text"></p>
    }

    <p>To confirm, please type "{{ confirmationInput }}" below:</p>

    <input
      data-dd-action-name="confirmation-modal.confirmation-input"
      type="text"
      class="form-control"
      formControlName="confirmation"
      ngbAutofocus
      [class.is-invalid]="
        form.controls.confirmation.touched && form.controls.confirmation.invalid
      "
    />
    @if (form.controls.confirmation.getError('unmatched'); as error) {
      <div class="invalid-feedback">The value entered must exactly match.</div>
    }
  </div>

  <div class="modal-footer">
    @if (showCancelButton) {
      <button
        data-dd-action-name="confirmation-modal.cancel-button"
        type="button"
        class="btn btn-outline"
        (click)="activeModal.close('Cancel')"
      >
        {{ cancelButtonLabel || 'Cancel' }}
      </button>
    }

    <button
      data-dd-action-name="confirmation-modal.confirm-button"
      type="submit"
      class="btn btn-danger"
    >
      {{ confirmButtonLabel || 'OK' }}
    </button>
  </div>
</form>
